<template>
	<helio-button
		class="button-block"
		:link="block.content.url"
		:text="block.content.text"
	/>
</template>

<script>
import Button from '../../../button/Button.vue';

export default {
	components: {
		'helio-button': Button,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		next: {
			type: Object,
			required: false,
			default: null,
		},
	},
};
</script>

<style lang="scss" src="./button-block.scss" />
